<template>
  <div class="maincen">
    <div class="inventory-box" :style="{ height: `${tableViewHeight}px` }">
      <div class="headertable">
        <span class="hspan" style="width: 280px">联系人</span>
        <span class="hspan right" style="width: 100px">操作</span>
      </div>
      <ul class="inventory-list">
        <li class="" v-for="(inventory, index) in lists" :key="index">
          <span class="widthspan" style="width: 280px">{{
            inventory.pressName
          }}</span>
          <span class="" style="width: 100px"
            ><el-button @click.stop="contactPress(inventory)" type="text"
              >回告留言</el-button
            >
          </span>
        </li>
      </ul>
    </div>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page="pageBean.pageNum"
        :page-size="pageBean.pageSize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <huiGaoDailog
      @updateVisible="updateVisible"
      :dialogInfo="dialogInfo"
      :visible.sync="dialogVisibleGao"
    ></huiGaoDailog>
  </div>
</template>
<script>
import { pressList } from '../../api/index'
import huiGaoDailog from '../common/huiGaoDialog.vue'
export default {
  data() {
    return {
      lists: [],
      total: 0,
      msg: '',
      tableViewHeight: 0,
      dialogVisible: false,
      pageBean: {
        pageNum: 1,
        pageSize: 10,
      },
      dialogVisibleGao: false,
      dialogInfo: null,
    }
  },
  components: {
    huiGaoDailog,
  },
  created() {
    this.gitList()
    this.$nextTick(() => {
      this.tableViewHeight =
        window.innerHeight -
        document.getElementsByClassName('inventory-box')[0].offsetTop -
        130
    })
  },
  methods: {
    // 修改是否让页面显示与隐藏的事件
    updateVisible(val) {
      this.dialogVisibleGao = val
    },
    contactPress(Info) {
      this.dialogInfo = Info
      this.dialogInfo.platformId = Info.pressId
      this.dialogVisibleGao = true
    },
    handleCurrentChange(page) {
      this.pageBean.pageNum = page
      this.gitList()
    },
    gitList() {
      pressList(this.pageBean)
        .then((res) => {
          this.lists = res && res.data
          this.total = res.page.total
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style>
.btn-prev {
  margin-right: 15px !important;
}
</style>
<style lang="scss" >
.buttoncao {
  height: 48px;
  display: block;
  margin-top: 30px;
  align-items: center;
  .el-button {
    font-size: 14px;
  }
}

.widthspan button {
  padding-top: 0px;
}
.widthspan {
  display: inline-block;
  width: 170px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #333333;
  font-weight: bold;
}
.right {
  float: right;
}
.hspan {
  display: inline-block;
  width: 170px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: white;
}
.headertable {
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  background-color: #274c9f;
  color: white;
}
.rightbutton {
  float: right;
  width: 120px;
  height: 40px;
  background: #274c9f;
  border: 1px solid #274c9f;
  border-radius: 4px;
  line-height: 40px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.catalogTit {
  display: inline-block;
}
.maincen {
  margin: 0 0px !important;
  min-height: 712px;
  // padding:0 20px;
  // background-color: white;
}
.catalog {
  overflow: hidden;
  padding: 0px 0 10px;
  line-height: 40px;
  .line {
    width: 8px;
    height: 18px;
    background: #274c9f;
    float: left;
    margin-right: 8px;
    margin-top: 11px;
  }
  .catalogTit {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 40px;
  }
}
</style>
<style lang="scss" scoped>
.deletebutton {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #a13e38;
}
.detailbutton {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9a2b;
}
.inventory-box {
  background-color: white;
  border: 1px solid #e6e6e6;
  border-bottom: 50px;
  width: 100%;
  .inventory-list {
    padding: 0 20px;
  }
}
.inventory-list li {
  font-family: Microsoft YaHei;
  display: flex;
  align-items: center;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px dashed #e6e6e6;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.inventory-list li h1 {
  width: 170px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
  margin-bottom: 20px;
  float: left;
  overflow: hidden;
}
.inventory-list li span {
  float: left;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
}
.inventory-list li span.reviewe-delay {
  color: #ff9a2b;
}
.inventory-list li span.reviewe-finish {
  color: #075a03;
}
.inventory-list li span.reviewe-rough {
  color: #999999;
}
.inventory-list li span.reviewe-lose {
  color: #0082f0;
}
.inventory-list li span.time a {
  text-decoration: none;
  outline: none;
  color: #999999;
}
.inventory-list li span.time {
  float: right;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
}
.inventory-list li span.time i {
  font-style: normal;
}
</style>
